import React, { useEffect, useState } from 'react';
import { ArrowRightIcon, ShieldIcon, ClockIcon, LockIcon } from 'lucide-react';
export function FinalCTA() {
  // 15 minutes countdown
  const [timeLeft, setTimeLeft] = useState(15 * 60);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const minutes = Math.floor(timeLeft / 60).toString().padStart(2, '0');
  const seconds = (timeLeft % 60).toString().padStart(2, '0');
  return <section className="py-24 bg-gradient-to-br from-coral to-rose relative overflow-hidden" data-id="element-44">
      {/* Background patterns */}
      <div className="absolute inset-0 opacity-10" style={{
      backgroundImage: 'radial-gradient(circle at 2px 2px, white 1px, transparent 0)',
      backgroundSize: '24px 24px'
    }} data-id="element-45"></div>

      <div className="container mx-auto px-4 max-w-4xl text-center relative z-10 fade-in-section" data-id="element-46">
        <h2 className="text-4xl md:text-5xl font-black text-white mb-6 drop-shadow-md" data-id="element-47">
          Tu transformación empieza hoy
        </h2>

        <div className="bg-white/10 backdrop-blur-md border border-white/20 rounded-3xl p-8 md:p-12 shadow-2xl max-w-2xl mx-auto" data-id="element-48">
          <p className="text-white/90 text-lg font-medium mb-4 uppercase tracking-wider" data-id="element-49">
            ⏰ Tu lugar con descuento queda reservado por:
          </p>

          <div className="flex justify-center items-center gap-4 mb-8" data-id="element-50">
            <div className="bg-white text-coral-dark text-5xl md:text-6xl font-black rounded-xl p-4 min-w-[100px] shadow-inner" data-id="element-51">
              {minutes}
            </div>
            <span className="text-white text-4xl font-bold" data-id="element-52">:</span>
            <div className="bg-white text-coral-dark text-5xl md:text-6xl font-black rounded-xl p-4 min-w-[100px] shadow-inner" data-id="element-53">
              {seconds}
            </div>
          </div>

          <p className="text-white/80 text-sm mb-6 -mt-4" data-id="element-54">
            Después de este tiempo, el precio vuelve a $41.000
          </p>

          <div className="mb-8" data-id="element-55">
            <div className="inline-flex items-center gap-2 bg-white/20 px-3 py-1 rounded-full text-xs font-bold text-white mb-3" data-id="element-56">
              <span className="relative flex h-2 w-2" data-id="element-57">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-400 opacity-75" data-id="element-58"></span>
                <span className="relative inline-flex rounded-full h-2 w-2 bg-red-500" data-id="element-59"></span>
              </span>
              Últimas 14 unidades disponibles
            </div>
            <p className="text-white/80 line-through text-xl mb-1" data-id="element-60">
              Valor normal: $41.000
            </p>
            <p className="text-white text-4xl font-bold" data-id="element-61">Hoy solo: $14.999</p>
          </div>

          <a href="https://reiniciatumetabolismo.lat/cart/43809396064391:1?checkout" onClick={() => {
          if (typeof window !== 'undefined' && (window as any).fbq) {
            ;
            (window as any).fbq('track', 'AddToCart');
          }
        }} className="group relative inline-flex items-center justify-center px-8 py-5 text-xl font-black text-coral-dark bg-white rounded-full shadow-[0_0_40px_rgba(255,255,255,0.4)] hover:scale-105 transition-all duration-300 animate-pulse-soft w-full" data-id="element-62">
            ¡SÍ! Quiero reiniciar mi metabolismo AHORA
            <ArrowRightIcon className="ml-3 group-hover:translate-x-2 transition-transform" size={28} data-id="element-63" />
          </a>

          <p className="text-white/90 text-sm mt-4 mb-6 font-medium" data-id="element-64">
            → Hacé clic y empezá tu transformación en menos de 2 minutos
          </p>

          <div className="flex flex-wrap justify-center items-center gap-6 mt-2 text-sm text-white/90 font-medium" data-id="element-65">
            <div className="flex items-center" data-id="element-66">
              <LockIcon size={18} className="mr-2" data-id="element-67" />
              <span data-id="element-68">Pago seguro</span>
            </div>
            <div className="flex items-center" data-id="element-69">
              <ClockIcon size={18} className="mr-2" data-id="element-70" />
              <span data-id="element-71">Acceso inmediato</span>
            </div>
            <div className="flex items-center" data-id="element-72">
              <ShieldIcon size={18} className="mr-2" data-id="element-73" />
              <span data-id="element-74">Garantía 7 días</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}